import { useEffect, useRef } from 'react'

import { mapEventToFormData } from '@components/MatchEventEditor/utils'

import { useMatchEditorFormContext } from '@contexts/MatchEditorFormContext'
import { useSelectedEventContext } from '@contexts/SelectedEventContext'

import { useEventFormOptions } from './useEventFormOptions'

export function useEventFormHydration() {
    const { selectedEvent } = useSelectedEventContext()
    const { resetForm, setIsAdditionalTimeSelected, setIsFormDisabled } = useMatchEditorFormContext()
    const options = useEventFormOptions()

    const hydratedEventIdRef = useRef<string | null>(null)

    useEffect(() => {
        const currentEventId = selectedEvent ? String(selectedEvent.id) : null

        // Already hydrated → do nothing
        if (hydratedEventIdRef.current === currentEventId) {
            return
        }

        // New Event
        if (!selectedEvent) {
            hydratedEventIdRef.current = null

            resetForm()

            setIsAdditionalTimeSelected(false)

            setIsFormDisabled(false)

            return
        }

        // Guard: options must exist
        if (!options.periods.length || !options.teams.length || !Object.values(options.players).flat().length) {
            return
        }

        const { formData, isAdditionalTimeSelected } = mapEventToFormData(selectedEvent, options)
        setIsAdditionalTimeSelected(isAdditionalTimeSelected)

        setIsFormDisabled(!selectedEvent.isEditable)

        resetForm(formData)

        // Mark as hydrated after successful hydration
        hydratedEventIdRef.current = currentEventId
    }, [selectedEvent, options, resetForm, setIsAdditionalTimeSelected, setIsFormDisabled])
}
